<template>
	<b-nav-item v-if="auction.url_ncr" :href="auction.url_ncr" target="_blank" :class="[hasClass]">
		<span v-if="mini">
			<font-awesome-icon :icon="['fas', 'video']" size="lg" class="text-white" />
		</span>
		<span v-else>
			<font-awesome-icon :icon="['fas', 'video']" size="lg" class="mr-2 text-white" />
			<span class="text-white">¡REMATE EN VIVO!</span>
		</span>
	</b-nav-item>
</template>
<script>
  export default {
	name: 'v-auction',
	data (){
		return {
            auction: {url_ncr: ""},
            text: "¡Hay un remate en vivo!"
        }
	},
	props:{
		hasClass: {default: ""},
		mini: {default: false}
	},
    mounted(){
        this.setcurrent()
    },
	methods:{
		setcurrent(){
			let self = this;
			this.axios.get("auctions/current").then(result => {
                if(typeof result.data.length != undefined){
                  self.auction = result.data;
                }
			}).catch(() => {
			})
		}
	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auction-button {
    display: block;
    text-decoration: none;
}

.btn-auction{
	font-weight: bold;
    background-color: #E4610C;
	animation: fadeinphoto 2s infinite; 
	-moz-animation: fadeinphoto 2s infinite; 
	-webkit-animation: fadeinphoto 2s infinite; 
	-o-animation: fadeinphoto 2s infinite;
}

/* Animation Keyframes*/
@keyframes fadeinphoto {
    0% { background-color: #E4610C; }
    50% { background-color: #FE2020; }
    100% { background-color: #E4610C; }
}

@-moz-keyframes fadeinphoto {
    0% { background-color: #E4610C; }
    50% { background-color: #FE2020; }
    100% { background-color: #E4610C; }
}

@-webkit-keyframes fadeinphoto {
    0% { background-color: #E4610C; }
    50% { background-color: #FE2020; }
    100% { background-color: #E4610C; }
}

@-o-keyframes fadeinphoto {
    0% { background-color: #E4610C; }
    50% { background-color: #FE2020; }
    100% { background-color: #E4610C; }
}
</style>
